/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React, { useState } from 'react';
import { UIButton, UITag, UISpace } from '@adp-arch/bot-semi';
import { Typography } from '@coze-arch/coze-design';
import { useLicense } from './hooks/useLicense';
import { ActivationModal } from './ActivationModal';

const { Text } = Typography;

export const LicenseInfo: React.FC = () => {
    const { licenseInfo } = useLicense();
    const [modalVisible, setModalVisible] = useState(false);

    if (!licenseInfo) return null;

    const editionMap: Record<string, { label: string; color: string }> = {
        enterprise: { label: '企业版', color: 'blue' },
        ultimate: { label: '旗舰版', color: 'purple' },
    };

    const edition = editionMap[licenseInfo.edition] || { label: '社区版', color: 'grey' };

    if (!licenseInfo.is_activated) {
        return (
            <>
                <UIButton
                    type="primary"
                    theme="solid"
                    size="small"
                    onClick={() => setModalVisible(true)}
                >
                    激活系统
                </UIButton>
                <ActivationModal
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                />
            </>
        );
    }

    return (
        <UISpace spacing="small">
            <UITag color={edition.color as any} shape="circle" type="light">
                {edition.label}
            </UITag>
            <Text type="secondary" style={{ fontSize: '12px' }}>
                v{licenseInfo.version}
            </Text>
        </UISpace>
    );
};
